export const pendingListTranslations = {
  en: {
    managers_tab: "Managers",
    fighters_tab: "Athletes",
    loading: "Loading...",
        gender: "Gender",
    gender_placeholder: "Gender",
    Male: "Male",
    Female: "Female",
    Others: "Others",
    table: {
      name: "Name",
      phone: "Phone",
      location: "Location",
      type: "Type",
      organization: "Organization",
      disciplines: "Disciplines",
      weightClass: "Weight Class",
      title: "Title",
      status: "Status",
      actions: "Actions",
      empty: "No data available",
    },
    tooltip: {
      edit: "Edit",
    },
    yes: "Yes",
    no: "No",
    na: "N/A",
  },
  de: {
    managers_tab: "Manager",
    fighters_tab: "Athleten",
    loading: "Laden...",
        gender: "Geschlecht",
    gender_placeholder: "Geschlecht",
    Male: "Männlich",
    Female: "Weiblich",
    Others: "Andere",
    table: {
      name: "Name",
      phone: "Telefon",
      location: "Standort",
      type: "Typ",
      organization: "Organisation",
      disciplines: "Disziplinen",
      weightClass: "Gewichtsklasse",
      title: "Titel",
      status: "Status",
      actions: "Aktionen",
      empty: "Keine Daten verfügbar",
    },
    tooltip: {
      edit: "Bearbeiten",
    },
    yes: "Ja",
    no: "Nein",
    na: "N/V",
  },
  hr: {
    managers_tab: "Menadžeri",
    fighters_tab: "Sportaši",
    loading: "Učitavanje...",
        gender: "Spol",
    gender_placeholder: "Spol",
    Male: "Muško",
    Female: "Žensko",
    Others: "Ostalo",
    table: {
      name: "Ime",
      phone: "Telefon",
      location: "Lokacija",
      type: "Vrsta",
      organization: "Organizacija",
      disciplines: "Discipline",
      weightClass: "Težinska kategorija",
      title: "Naslov",
      status: "Status",
      actions: "Akcije",
      empty: "Nema dostupnih podataka",
    },
    tooltip: {
      edit: "Uredi",
    },
    yes: "Da",
    no: "Ne",
    na: "N/A",
  },
};
